import { communicationsStatusPageEntrypoint } from '@jira/communications__status-page/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { horizontalStatusPageNavEntrypoint } from '@atlassian/jira-horizontal-nav-status-page/entrypoint.tsx';

export const StatusPageEntryPoint = createPageEntryPoint({
	main: communicationsStatusPageEntrypoint,
	topNavigationMenuId: MENU_ID.STATUS_PAGE_MANAGE,
	horizontalNavigation: horizontalStatusPageNavEntrypoint,
});
